<template>
  <div
    :class="{
      'flex justify-between overflow-auto': variant === 'row'
    }"
  >
    <Status
      v-for="status in ['pending', 'approved', 'dismissed']"
      :key="status"
      class="cursor-pointer"
      :is-flat="variant === 'row'"
      :is-active="selectedStatus === status"
      :note="questions.filter((question) => question.status === status).length"
      @click="handleActiveStatusChange(status)"
    >
      {{ status }}
    </Status>
  </div>
</template>

<script>
import Status from '@/components/question-moderation/Status.vue'

export default {
  components: {
    Status,
  },
  props: {
    selectedStatus: {
      type: String,
      default: 'pending',
    },
    variant: {
      type: String,
      default: 'column',
    },
    questions: {
      type: Array,
      required: true,
    },
    handleActiveStatusChange: {
      type: Function,
      required: true,
    },
  },
}
</script>
